import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';

const UserFemaleIcon = (props) => (
  <SvgIcon viewBox="0 0 16 16" {...props}>
    <path
      d="M8.00005 1.33325C5.46205 1.33325 1.71606 3.14466 1.36073 11.9413C1.33006 12.698 1.9387 13.3333 2.69536 13.3333H4.48573C5.42577 14.1605 6.6544 14.6666 8.00005 14.6666C9.3457 14.6666 10.5743 14.1605 11.5144 13.3333H13.3047C14.0614 13.3333 14.6707 12.698 14.6407 11.9413C14.2847 3.14466 10.5381 1.33325 8.00005 1.33325ZM5.33339 7.33325H10.6667C11.4034 7.33325 12.0001 7.92992 12.0001 8.66658V9.33325C12.0001 11.5503 10.2171 13.3333 8.00005 13.3333C5.78301 13.3333 4.00005 11.5503 4.00005 9.33325V8.66658C4.00005 7.92992 4.59672 7.33325 5.33339 7.33325Z"
      fill={props.sx?.color || '#E873D8'}
    />
  </SvgIcon>
);

UserFemaleIcon.propTypes = {
  sx: PropTypes.object,
};

export default UserFemaleIcon;
